import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from './pages/EditPage';
import {useVerifiedPermissions} from "../../hooks/useVerifiedPermissions.ts";

export const DomainNamesLayout = () => {

    const {allowedActions} = useVerifiedPermissions()

    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes('ListDomainNames') ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path='add'
                element={
                    allowedActions.includes('CreateDomainName') ? (
                        <AddPage/>
                    ) : (
                        <Navigate to='/domain-names'/>
                    )
                }
            />

            <Route
                path=':id'
                element={
                    allowedActions.includes('GetDomainName') ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/domain-names'/>
                    )
                }
            />
        </Routes>
    );
};
